import { PuffLoader } from "react-spinners";

const Spinner = ({ loading }) => {
	return <PuffLoader color="black" size={45} loading={loading} />;
};

export default Spinner;
